// extracted by mini-css-extract-plugin
module.exports = {"skeleton":"styles_skeleton__Qycc_","loading":"styles_loading__det_m"};